import { BASE_CLASS_PREFIX } from '../base/constants';
const cssClasses = {
  PREFIX: "".concat(BASE_CLASS_PREFIX, "-switch"),
  LARGE: "".concat(BASE_CLASS_PREFIX, "-switch-large"),
  SMALL: "".concat(BASE_CLASS_PREFIX, "-switch-small"),
  CHECKED: "".concat(BASE_CLASS_PREFIX, "-switch-checked"),
  DISABLED: "".concat(BASE_CLASS_PREFIX, "-switch-disabled"),
  ACTIVE: "".concat(BASE_CLASS_PREFIX, "-switch-active"),
  KNOB: "".concat(BASE_CLASS_PREFIX, "-switch-knob"),
  NATIVE_CONTROL: "".concat(BASE_CLASS_PREFIX, "-switch-native-control"),
  CHECKED_TEXT: "".concat(BASE_CLASS_PREFIX, "-switch-checked-text"),
  UNCHECKED_TEXT: "".concat(BASE_CLASS_PREFIX, "-switch-unchecked-text"),
  LOADING_SPIN: "".concat(BASE_CLASS_PREFIX, "-switch-loading-spin"),
  LOADING: "".concat(BASE_CLASS_PREFIX, "-switch-loading")
};
const strings = {
  SIZE_MAP: ['default', 'small', 'large']
};
export { cssClasses, strings };